import { getDateInTimeZone } from 'utils/events';

type BooleansForDisplayingTicketLabels = {
  displaySoldToDate: boolean;
  displaySoldFromDate: boolean;
  ticketIsSellable: boolean;
};

export const getBooleansForDisplayingTicketLabels = (
  ends_at: string | null,
  timezone: string,
  sold_from: string | null,
  sold_to: string | null,
  sold_out: boolean,
): BooleansForDisplayingTicketLabels => {
  let displaySoldToDate = false;
  let displaySoldFromDate = false;
  let ticketIsSellable = true;

  // sales interval has set both dates
  if (sold_from && sold_to) {
    const soldFromDate = getDateInTimeZone(sold_from, timezone);
    const soldToDate = getDateInTimeZone(sold_to, timezone);
    const ticketIsUpcoming = soldFromDate.diffNow('seconds').seconds > 0;

    // soldFrom text has priority over sold to
    // so if we don't display soldFrom, we show sold_to
    if (ticketIsUpcoming) {
      displaySoldFromDate = true;
      ticketIsSellable = false;
    } else {
      const salesEnded = soldToDate.diffNow('seconds').seconds <= 0;
      displaySoldToDate = !salesEnded && !sold_out;
      ticketIsSellable = displaySoldToDate;
    }
  } else if (sold_from) {
    // sold_to = null <=> sold_to = event's start date
    const soldFromDate = getDateInTimeZone(sold_from, timezone);
    const ticketIsUpcoming = soldFromDate.diffNow('seconds').seconds > 0;

    if (ticketIsUpcoming) {
      displaySoldFromDate = true;
      ticketIsSellable = false;
    } else {
      if (ends_at) {
        const soldToDate = getDateInTimeZone(ends_at, timezone);
        const salesEnded = soldToDate.diffNow('seconds').seconds <= 0;
        displaySoldToDate = !salesEnded && !sold_out;
        ticketIsSellable = displaySoldToDate;
      } else {
        ticketIsSellable = true;
      }
    }
  } else if (sold_to) {
    const soldToDate = getDateInTimeZone(sold_to, timezone);
    const salesEnded = soldToDate.diffNow('seconds').seconds <= 0;

    if (salesEnded) {
      ticketIsSellable = false;
    } else {
      displaySoldToDate = !sold_out;
      ticketIsSellable = !sold_out;
    }
  } else {
    ticketIsSellable = !sold_out;
  }

  return {
    displaySoldToDate,
    displaySoldFromDate,
    ticketIsSellable,
  };
};
